import React from 'react';
import { Check, Star } from 'lucide-react';
import { ValuanLogo } from './ValuanLogo';
const PLANS = [{
  name: 'Plan Impulso',
  price: '$1,746',
  subtitle: 'Hasta 3 suscriptores',
  recommended: false,
  link: 'https://api.whatsapp.com/send?phone=525511362283&text=Me interesa prueba gratuita de Valuan con el Plan Impulso'
}, {
  name: 'Plan Escala',
  price: '$2,947',
  subtitle: 'Hasta 10 suscriptores',
  recommended: true,
  link: 'https://api.whatsapp.com/send?phone=525511362283&text=Me interesa prueba gratuita de Valuan con el Plan Escala'
}, {
  name: 'Business Pro',
  price: '$3,597',
  subtitle: 'Suscriptores ilimitados',
  recommended: false,
  link: 'https://api.whatsapp.com/send?phone=525511362283&text=Me interesa prueba gratuita de Valuan con el Plan Business Pro'
}];
export function PricingSection() {
  return <section className="px-4 md:px-8 py-12 max-w-7xl mx-auto" data-id="element-188">
      <div className="bg-[#1F46D5] rounded-[3rem] p-8 md:p-16 text-center" data-id="element-189">
        <h2 className="text-card-heading-white !text-[48px] !leading-[52px] md:!text-[65px] md:!leading-[68px] !font-bold mb-4" data-id="element-190">
          Corta el gasto
          <br data-id="element-191" />
          innecesario
        </h2>
        <p className="text-body !text-white/80 mb-12" data-id="element-192">
          Reemplaza +10 herramientas por un solo pago inteligente.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-193">
          {PLANS.map(plan => <div key={plan.name} className={`rounded-3xl p-8 flex flex-col justify-between relative overflow-hidden ${plan.recommended ? 'bg-[#F77730] text-white ring-4 ring-white/30 scale-[1.03]' : 'bg-[#F0F0F3] text-gray-900'}`} data-id="element-194">
              {plan.recommended && <div className="bg-white text-[#F77730] text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-wide z-10 mx-auto mb-4" data-id="element-195">
                  Recomendado
                </div>}
              {plan.recommended && <div className="absolute top-0 right-0 w-48 h-48 bg-white/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4" data-id="element-196"></div>}

              <div data-id="element-197">
                <h3 className="text-lg font-bold mb-1 relative z-10" data-id="element-198">
                  {plan.name}
                </h3>
                <p className={`text-sm mb-6 relative z-10 ${plan.recommended ? 'text-white/80' : 'text-gray-500'}`} data-id="element-199">
                  {plan.subtitle}
                </p>

                <div className="mb-6 relative z-10" data-id="element-200">
                  <span className="text-[42px] md:text-[50px] font-bold leading-none" data-id="element-201">
                    {plan.price}
                  </span>
                  <span className={`text-base ml-2 ${plan.recommended ? 'text-white/90' : 'text-gray-500'}`} data-id="element-202">
                    MXN /mes
                  </span>
                </div>
              </div>

              <a href={plan.link} target="_blank" rel="noopener noreferrer" className="text-btn w-full bg-[#1F46D5] py-4 rounded-full hover:bg-[#152E8A] transition-colors shadow-lg relative z-10 !text-[16px] inline-block text-center" data-id="element-203">
                Prueba Gratis 7 Días
              </a>
            </div>)}
        </div>

        {/* Reviews */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto mt-8" data-id="element-204">
          {['La automatización de Valuan ha ahorrado horas a nuestro equipo. Increíble plataforma.', 'Implementación perfecta y soporte excepcional. Nuestra productividad aumentó un 40%.'].map((review, i) => <div key={i} className="bg-[#F77730] rounded-2xl p-6 text-left shadow-lg" data-id="element-205">
              <div className="flex gap-1 mb-3" data-id="element-206">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-white fill-white" data-id="element-207" />)}
              </div>
              <p className="text-body !text-white !text-[14px] !leading-[20px]" data-id="element-208">
                "{review}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}